import { render, staticRenderFns } from "./BindSupplier.vue?vue&type=template&id=f859974a&scoped=true"
import script from "./BindSupplier.vue?vue&type=script&lang=js"
export * from "./BindSupplier.vue?vue&type=script&lang=js"
import style0 from "./BindSupplier.vue?vue&type=style&index=0&id=f859974a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f859974a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f859974a')) {
      api.createRecord('f859974a', component.options)
    } else {
      api.reload('f859974a', component.options)
    }
    module.hot.accept("./BindSupplier.vue?vue&type=template&id=f859974a&scoped=true", function () {
      api.rerender('f859974a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/clientManage/coupons/dialogs/ProductConfig/dialogs/BindSupplier.vue"
export default component.exports